

























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import * as elements from "@/shared/elementsUrls";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import * as RouteNames from "@/employee/route-names";
import { FetchState } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class DisclosureLinks extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  featureFlags = useFeatureFlagStore();
  wizardStore = useDrivewealthWizardStore();

  ElementsUrls = elements;
  RouteNames = RouteNames;

  open (url) {
    openUrl(url, AppBrowserTarget.system);
  }

  get showElementsFeeSchedule () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.Elements;
  }

  get equitiesDripDisclosureUrl () {
    return "https://legal.drivewealth.com/dividend-reinvestment-program-drip-disclosure";
  }

  get isMobile () {
    return isMobileApp();
  }

  get isHsab () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
